<template>
    <v-dialog v-model="openMode" max-width="480px" content-class="send-call-dialog-wrapper">
        <v-card class="send-call-dialog" rounded="xl" elevation="12">

            <!-- Header -->
            <div class="dialog-header">
                <div class="header-icon-wrapper">
                    <v-icon size="32" color="white">mdi-bell-ring-outline</v-icon>
                </div>
                <v-card-title class="dialog-title">
                    Send Call to All Users
                </v-card-title>
                <p class="dialog-subtitle">
                    The call will be sent to all users who have opted in to receive calls
                </p>
            </div>

            <!-- Divider -->
            <v-divider class="mx-6" style="opacity: 0.12;"></v-divider>

            <!-- Body -->
            <v-card-text class="dialog-body">
                <div class="confirmation-box">
                    <v-icon color="#F59E0B" size="20" class="mr-2">mdi-alert-circle-outline</v-icon>
                    <span>Are you sure you want to proceed with this action?</span>
                </div>
            </v-card-text>

            <!-- Loading -->
            <v-row v-if="progressShow" class="my-0">
                <v-col class="d-flex justify-center py-4">
                    <v-progress-circular indeterminate color="#0d2c6d" :size="36" :width="3"></v-progress-circular>
                </v-col>
            </v-row>

            <!-- Actions -->
            <v-card-actions class="dialog-actions">
                <v-btn class="action-btn cancel-btn" rounded="lg" variant="outlined" height="42" @click="closeDelete">
                    <v-icon size="18" class="mr-1">mdi-close</v-icon>
                    Cancel
                </v-btn>
                <v-btn class="action-btn confirm-btn" rounded="lg" height="42" :loading="progressShow"
                    @click="sendCallToAll">
                    <v-icon size="18" class="mr-1">mdi-send</v-icon>
                    Send to All
                </v-btn>
            </v-card-actions>

        </v-card>

        <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>

    </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
    props: {
        value: { type: Boolean, default: false },
    },
    components: {
        SnackBar,
    },
    data: () => ({
        progressShow: false,
        snackbar: false,
        snackbarColorBt: "green",
        snacbarText: "",
    }),

    methods: {
        async sendCallToAll() {
            try {
                this.progressShow = true;
                let token = localStorage.getItem("token");
                let api = process.env.VUE_APP_BASE_URL + "/subscribes/send_call_to_all_subscribers";
                const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
                if (res.status >= 400) {
                    this.showSnackBar("Error sending call", "red")
                    this.progressShow = false;
                } else if (res.status === 200) {
                    this.showSnackBar("Action performed successfully!", "green")
                    this.progressShow = false;
                    setTimeout(() => {
                        this.openMode = false;
                    }, 1500);
                }
            } catch (error) {
                this.progressShow = false;
                this.showSnackBar("Error sending call: " + error, "red")
            }
        },
        closeDelete() {
            this.openMode = false;
        },
        showSnackBar(message, color) {
            this.snacbarText = message;
            this.snackbarColorBt = color;
            this.snackbar = true
        },
    },
    computed: {
        openMode: {
            get() {
                return this.value
            },
            set(v) {
                return this.$emit('input', v)
            }
        },
    },
}
</script>

<style scoped>
.send-call-dialog {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    overflow: hidden;
    direction: ltr;
}

/* Header */
.dialog-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px 24px 20px;
    text-align: center;
}

.header-icon-wrapper {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, #1a4494, #0d2c6d);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    box-shadow: 0 4px 15px rgba(13, 44, 109, 0.3);
}

.dialog-title {
    font-size: 1.2rem !important;
    font-weight: 700 !important;
    color: #1E293B;
    padding: 0 !important;
    margin-bottom: 8px;
    line-height: 1.4;
    word-break: break-word;
    white-space: normal;
}

.dialog-subtitle {
    font-size: 0.85rem;
    color: #64748B;
    margin: 0;
    line-height: 1.5;
}

/* Body */
.dialog-body {
    padding: 20px 24px !important;
}

.confirmation-box {
    display: flex;
    align-items: center;
    background: #FFFBEB;
    border: 1px solid #FDE68A;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 0.875rem;
    color: #92400E;
}

/* Actions */
.dialog-actions {
    display: flex;
    justify-content: center;
    gap: 12px;
    padding: 8px 24px 24px !important;
}

.action-btn {
    flex: 1;
    max-width: 180px;
    font-weight: 600 !important;
    font-size: 0.875rem !important;
    letter-spacing: 0 !important;
    text-transform: none !important;
}

.cancel-btn {
    color: #64748B !important;
    border-color: #E2E8F0 !important;
    background: #F8FAFC !important;
}

.cancel-btn:hover {
    background: #F1F5F9 !important;
    border-color: #CBD5E1 !important;
}

.confirm-btn {
    background: linear-gradient(135deg, #1a4494, #0d2c6d) !important;
    color: white !important;
    box-shadow: 0 2px 8px rgba(13, 44, 109, 0.3);
}

.confirm-btn:hover {
    box-shadow: 0 4px 14px rgba(13, 44, 109, 0.45);
}
</style>